import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NegocioService } from "./api-negocio.service";
import { DetalheClienteCompletoSignature } from "../../../shared/models/signature/detalheClienteCompletoSignature";
import { FiltrosNegocioSignature } from "../../../shared/models/signature/FiltrosNegocioSignature";
import { BloquearDesbloquearNegocioSignature } from "../../../shared/models/signature/BloquearDesbloquearNegocioSignature";
import { GetNegocioSignature } from "../../../shared/models/signature/GetNegocioSignature";
import { GetNegocioAgendamentoDiaSignature } from "../../../shared/models/signature/GetNegocioAgendamentoDiaSignature";
import { GetNegocioCompartilheiSignature } from "../../../shared/models/signature/GetNegocioCompartilheiSignature";
import { GetNegocioCompartilhadoComigoSignature } from "../../../shared/models/signature/GetNegocioCompartilhadoComigoSignature";
import { ExcluirClienteSignature } from "../../../shared/models/signature/ExcluirClienteSignature";
import { ExcluirNegocioSignature } from "../../../shared/models/signature/ExcluirNegocioSignature";
import { MarcarDesmarcarNegocioAcompanhamentoProcessoSignature } from "../../models/signature/MarcarDesmarcarNegocioAcompanhamentoProcessoSignature";
import { GetNegocioDasboardSignature } from "../../models/signature/GetNegocioDasboardSignature";

@Injectable({
  providedIn: 'root'
})

export class NegocioDataService {

  constructor(private api: NegocioService) {
  }

  public GetNegocio(signature: GetNegocioSignature): Observable<any>{
    return this.api.GetNegocio(signature);
  }

  public GetNegocioDashboard(signature: GetNegocioDasboardSignature): Observable<any>{
    return this.api.GetNegocioDashboard(signature);
  }

  public GetNegocioCliente(dealId: string): Observable<any>{
    return this.api.GetNegocioCliente(dealId);
  }

  public GetNegocioClienteCompleto(signature: DetalheClienteCompletoSignature): Observable<any>{
    return this.api.GetNegocioClienteCompleto(signature);
  }

  public GetNegocioCompartilhadoComigo(signature: GetNegocioCompartilhadoComigoSignature): Observable<any>{
    return this.api.GetNegocioCompartilhadoComigo(signature);
  }

  public GetNegocioAgendamentoDia(signature: GetNegocioAgendamentoDiaSignature): Observable<any>{
    return this.api.GetNegocioAgendamentoDia(signature);
  }

  public GetNegocioComFiltro(signature: FiltrosNegocioSignature): Observable<any>{
    return this.api.GetNegocioComFiltro(signature);
  }

  public BloquearDesbloquearNegocio(signature: BloquearDesbloquearNegocioSignature): Observable<any>{
    return this.api.BloquearDesbloquearNegocio(signature);
  }

  public GetPrimeiroNegocioDoClient(clientId: string): Observable<any>{
    return this.api.GetPrimeiroNegocioDoClient(clientId);
  }

  public GetNegocioCompartilhei(signature: GetNegocioCompartilheiSignature): Observable<any>{
    return this.api.GetNegocioCompartilhei(signature);
  }

  public ExcluirCliente(signature: ExcluirClienteSignature): Observable<any>{
    return this.api.ExcluirCliente(signature);
  }

  public ExcluirNegocio(signature: ExcluirNegocioSignature): Observable<any>{
    return this.api.ExcluirNegocio(signature);
  }

  public CarregarNegociosCliente(clientId: string): Observable<any> {
    return this.api.CarregarNegociosCliente(clientId);
  }

  public GetRendimentos(signature: {dataInicio?: string, dataFim?: string}): Observable<any>{
    return this.api.GetRendimentos(signature);
  }

  public CarregarListaNegocio(clientId: string): Observable<any>{
    return this.api.CarregarListaNegocio(clientId);
  }

  public CarregaTotalClientesPorUsuario(tipoTela: number): Observable<any>{
    return this.api.CarregaTotalClientesPorUsuario(tipoTela);
  }

  public MarcarNegocioAcompanhamentoProcesso(signature: MarcarDesmarcarNegocioAcompanhamentoProcessoSignature): Observable<any>{
    return this.api.MarcarNegocioAcompanhamentoProcesso(signature);
  }

  public GetPainelVendasTodos(signature: any = {}): Observable<any> {
    return this.api.GetPainelVendasTodos(signature);
  }

  public GetPainelVendasAgendaDia(signature: any): Observable<any> {
    return this.api.GetPainelVendasAgendaDia(signature);
  }

  public GetPainelVendasNaoTrabalhado(signature: any = {}): Observable<any> {
    return this.api.GetPainelVendasNaoTrabalhado(signature);
  }

  public GetPainelVendasDisponiveis(signature: any = {}): Observable<any> {
    return this.api.GetPainelVendasDisponiveis(signature);
  }

  public GetPainelVendasCompartilhei(signature: any = {}): Observable<any> {
    return this.api.GetPainelVendasCompartilhei(signature);
  }

  public GetPainelVendasCompartilharam(signature: any = {}): Observable<any> {
    return this.api.GetPainelVendasCompartilharam(signature);
  }

  public GetPainelVendasFechado(signature: any = {}): Observable<any> {
    return this.api.GetPainelVendasFechado(signature);
  }

  public GetNegocioDashBoardRedistribuicao(signature: GetNegocioDasboardSignature): Observable<any>{
    return this.api.GetNegocioDashBoardRedistribuicao(signature);
  }
}
